<template>
  <main class="page no-tabs">
    <page-header title="筛选客户" back @back="$router.back()" />
    <div v-if="loading" class="loading-state">
      <span class="spinner" />
      正在读取筛选条件
    </div>
    <p v-if="error" class="error-message">
      {{ error }}
      <button class="text-button" @click="load">重试</button>
    </p>
    <template v-if="!loading && searches.status">
      <form class="search-box" @submit.prevent="apply">
        <app-icon name="search" />
        <input v-model="form.searchKeyword" type="search" enterkeyhint="search" placeholder="姓名、电话、关键词" aria-label="搜索关键词" />
      </form>
      <section class="filter-group">
        <h2>按哪个时间筛选和排序</h2>
        <div class="option-chips">
          <button v-for="item in items('order')" :key="item.key" type="button" class="chip" :class="{ active: form.searchOrder === item.key }" @click="form.searchOrder = item.key">
            {{ item.value }}
          </button>
        </div>
      </section>
      <section class="filter-group">
        <h2>时间范围</h2>
        <div class="option-chips" style="margin-bottom:10px">
          <button v-for="item in ranges" :key="item.label" type="button" class="chip" :class="{ active: form.searchStartTime === item.start && form.searchEndTime === item.end }" @click="setRange(item)">
            {{ item.label }}
          </button>
        </div>
        <div class="range-row">
          <button type="button" class="range-btn" :class="{ ph: !form.searchStartTime }" @click="dateField = 'searchStartTime'">
            {{ form.searchStartTime ? dayText(form.searchStartTime) : '开始日期' }}
          </button>
          <span>至</span>
          <button type="button" class="range-btn" :class="{ ph: !form.searchEndTime }" @click="dateField = 'searchEndTime'">
            {{ form.searchEndTime ? dayText(form.searchEndTime) : '结束日期' }}
          </button>
        </div>
        <datetime-sheet :show="!!dateField" :title="dateField === 'searchStartTime' ? '开始日期' : '结束日期'" :value="dateField ? form[dateField] : ''" clearable @input="form[dateField] = $event" @close="dateField = ''" />
      </section>
      <section v-for="group in singleGroups" :key="group.name" class="filter-group">
        <h2>{{ group.label }}</h2>
        <div class="option-chips">
          <button v-if="group.name !== 'subject_type'" type="button" class="chip" :class="{ active: !form[group.field] }" @click="$set(form, group.field, '')">全部</button>
          <button v-for="item in items(group.name)" :key="item.key" type="button" class="chip" :class="{ active: String(form[group.field]) === String(item.key) }" @click="$set(form, group.field, item.key)">
            {{ item.value }}
          </button>
        </div>
      </section>
      <section v-for="group in multiGroups" :key="group.name" class="filter-group">
        <h2>{{ group.label }} <small>· 可多选</small></h2>
        <div class="option-chips">
          <button v-for="item in items(group.name)" :key="item.key" type="button" class="chip" :class="{ active: form[group.field].map(String).indexOf(String(item.key)) >= 0 }" @click="toggle(group.field, item.key)">
            {{ item.value }}
          </button>
        </div>
      </section>
      <div class="dock">
        <div class="dock-inner even">
          <button class="button outline" type="button" @click="reset">重置</button>
          <button class="button" type="button" @click="apply">查看客户</button>
        </div>
      </div>
    </template>
  </main>
</template>
<script>
import { validDay } from '../../common/schedule'
import DatetimeSheet from '../../components/datetime-sheet'
import { addDays, dateTimeText, dayString, today } from '../../common/when'
export default {
  components: { DatetimeSheet },
  data() {
    const form = JSON.parse(JSON.stringify(this.$store.state.search))
    form.searchStartTime = form.searchStartTime.slice(0, 10)
    form.searchEndTime = form.searchEndTime.slice(0, 10)
    return {
      form,
      searches: {},
      loading: true,
      error: '',
      dateField: '',
      singleGroups: [
        { name: 'status', field: 'searchStatus', label: '客户状态' },
        { name: 'labels', field: 'searchLabels', label: '意向等级' }
      ],
      multiGroups: [
        { name: 'source_channel_v2', field: 'searchSourceChannelV2', label: '客户来源' },
        { name: 'total_budget_range', field: 'searchTotalBudgetRange', label: '总价预算范围' },
        { name: 'price_acceptance_level', field: 'searchPriceAcceptanceLevel', label: '单价接受程度' },
        { name: 'purpose_v2', field: 'searchPurposeV2', label: '用途' },
        { name: 'employee', field: 'searchEmployees', label: '负责员工' }
      ]
    }
  },
  computed: {
    ranges() {
      const now = new Date()
      const base = today()
      const monthStart = dayString(new Date(now.getFullYear(), now.getMonth(), 1))
      const lastStart = dayString(new Date(now.getFullYear(), now.getMonth() - 1, 1))
      const lastEnd = dayString(new Date(now.getFullYear(), now.getMonth(), 0))
      return [
        { label: '不限', start: '', end: '' },
        { label: '今天', start: base, end: base },
        { label: '近 7 天', start: addDays(base, -6), end: base },
        { label: '本月', start: monthStart, end: base },
        { label: '上月', start: lastStart, end: lastEnd }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    items(name) {
      return (this.searches[name] && this.searches[name].list) || []
    },
    dayText(value) {
      return dateTimeText(value, false)
    },
    setRange(item) {
      this.form.searchStartTime = item.start
      this.form.searchEndTime = item.end
    },
    async load() {
      this.loading = true
      this.error = ''
      try {
        let data = this.$store.state.customer.state.searches
        if (!data.status) {
          data = (await this.$api.post('/api/base/searches', {})).data
          this.$store.state.customer.state.searches = data
        }
        this.searches = data
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },
    toggle(field, key) {
      const values = this.form[field]
      const index = values.map(String).indexOf(String(key))
      if (index < 0) values.push(key)
      else values.splice(index, 1)
    },
    reset() {
      Object.assign(this.form, {
        searchKeyword: '',
        searchStatus: '',
        searchLabels: '',
        searchOrder: 'created_at',
        searchSubjectType: 'subject',
        searchStartTime: '',
        searchEndTime: '',
        searchChannels: [],
        searchSubjects: [],
        searchEmployees: [],
        searchSourceChannelV2: [],
        searchTotalBudgetRange: [],
        searchPriceAcceptanceLevel: [],
        searchPurposeV2: []
      })
    },
    apply() {
      if (
        this.form.searchStartTime &&
        this.form.searchEndTime &&
        this.form.searchStartTime > this.form.searchEndTime
      ) {
        this.$toast('开始日期不能晚于结束日期')
        return
      }
      const copy = JSON.parse(JSON.stringify(this.form))
      copy.searchStartTime = copy.searchStartTime ? copy.searchStartTime + ' 00:00:00' : ''
      copy.searchEndTime = copy.searchEndTime ? copy.searchEndTime + ' 23:59:59' : ''
      Object.assign(this.$store.state.search, copy, { isSearch: true })
      this.$router.replace({
        path: '/customer',
        query: validDay(this.$route.query.schedule_date)
          ? {
              schedule_date: this.$route.query.schedule_date,
              schedule_type: this.$route.query.schedule_type === 'visit' ? 'visit' : 'follow'
            }
          : {}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customer/search.vue